export const productRecommendations: any = {
  inicial: {
    caspa: {
      produto: 'Shampoo Calvície Zero',
      descricao: 'Tratamento especializado que combate a calvície inicial, controla a queda de cabelo e elimina a caspa, promovendo um couro cabeludo saudável e fortalecendo os fios desde a raiz.',
    },
    oleoso: {
      produto: 'Shampoo Calvície Zero',
      descricao: 'Fórmula balanceada que controla a queda de cabelo e regula a oleosidade do couro cabeludo, mantendo os fios limpos por mais tempo e fortalecidos.',
    },
    inflamado: {
      produto: 'Shampoo Calvície Zero',
      descricao: 'Tratamento calmante que ajuda a acalmar o couro cabeludo, reduzir microinflamações e combater a queda de cabelo, proporcionando alívio e fortalecimento capilar.',
    },
    'caspa+oleoso': {
      produto: 'Shampoo Calvície Zero',
      descricao: 'Solução completa que trata calvície inicial, controla oleosidade excessiva e elimina a caspa, equilibrando o couro cabeludo e fortalecendo os fios.',
    },
    default: {
      produto: 'Shampoo Calvície Zero',
      descricao: 'Tratamento eficaz para calvície inicial que fortalece os fios, reduz a queda e promove o crescimento saudável do cabelo.',
    },
  },
  moderada: {
    default: {
      produto: 'Shampoo Calvície Zero + Tratamento Completo',
      descricao: 'Para calvície moderada, recomendamos nosso tratamento completo que combina o Shampoo Calvície Zero com produtos complementares para resultados mais efetivos e duradouros.',
    },
  },
  avancada: {
    default: {
      produto: 'Shampoo Calvície Zero + Tratamento Completo',
      descricao: 'Para calvície avançada, é essencial um tratamento completo e intensivo. Nosso protocolo especializado combina múltiplos produtos para maximizar os resultados e recuperar a saúde capilar.',
    },
  },
};
